"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalCard = void 0;
const mithril_1 = __importDefault(require("mithril"));
/**
* Create a modal
*/
function modalCard(options) {
    const handleEscape = (e) => {
        if ((options.isActive && (e.key == "Escape" || e.code == "Escape"))) {
            options.onClose(e);
            mithril_1.default.redraw();
            e.stopPropagation();
            e.preventDefault();
        }
    };
    if (!options.isActive)
        return undefined;
    return (0, mithril_1.default)("div", { class: "modal is-active",
        oncreate() { document.addEventListener("keydown", handleEscape); },
        onremove() { document.removeEventListener("keydown", handleEscape); },
        id: options.id,
        key: options.key
    }, (0, mithril_1.default)("div", { class: "modal-background" }), (0, mithril_1.default)("div", { class: "modal-card" }, (0, mithril_1.default)("header", { class: "modal-card-head" }, (0, mithril_1.default)("p", { class: "modal-card-title" }, options.title), (0, mithril_1.default)("button", {
        class: "delete", "aria-label": "close", onclick: (e) => {
            e.preventDefault();
            options.onClose && options.onClose(e);
        }
    })), (0, mithril_1.default)("section", { class: "modal-card-body" }, options.content), (0, mithril_1.default)("footer", { class: "modal-card-foot" }, options.foot)));
}
exports.modalCard = modalCard;
